module.exports = __webpack_public_path__ + "img/nakereba.3e0bccb8.png";